export default __webpack_public_path__ + "static/media/dead-end-sign.cabc9371.png";